import React from 'react';
import { ErrorMessage } from 'formik';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FieldContainer, Label, RequiredStar, SelectWrapper, ErrorText } from '../Styles';

export default function SelectField({
    name,
    label,
    value,
    onChange,
    options,
    placeholder = 'Select an option',
    required = false,
    error,
    touched,
}) {
    const isError = error && touched;

    return (
        <FieldContainer>
            <Label>
                {label}
                {required && <RequiredStar>*</RequiredStar>}
            </Label>

            <SelectWrapper $error={isError}>
                <Select
                    name={name}
                    value={value}
                    onChange={onChange}
                    className="w-full"
                    sx={{
                        height: "45px",
                        borderRadius: "8px",
                        backgroundColor: isError ? '#fef2f2' : 'transparent',
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: isError ? '#ef4444' : '#d1d5db',
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: isError ? '#ef4444' : '#9ca3af',
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: '#3b82f6',
                            borderWidth: '2px',
                        },
                    }}
                    displayEmpty
                >
                    <MenuItem value="" disabled>{placeholder}</MenuItem>
                    {options.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </SelectWrapper>

            <ErrorMessage name={name}>
                {msg => <ErrorText>{msg}</ErrorText>}
            </ErrorMessage>
        </FieldContainer>
    );
}